import React from "react";
import { benefits } from "./careersData";
import { benefitIcons } from "./icons";

const Benefits = () => {
    return (
        <section className="w-full">
            <style>{`
                .bn-card {
                    transition: transform .35s cubic-bezier(.22,.61,.36,1), box-shadow .35s ease, border-color .35s ease;
                }
                .bn-tile { transition: background-color .35s ease, border-color .35s ease; }
                @media (hover: hover) and (pointer: fine) {
                    .bn-card:hover {
                        transform: translateY(-4px);
                        border-color: #C9D3E2;
                        box-shadow: 0 14px 30px -18px rgba(15,20,36,0.28);
                    }
                    .bn-card:hover .bn-tile { background-color: #E3E9F3; border-color: #C4CEDC; }
                }
                @media (prefers-reduced-motion: reduce) {
                    .bn-card, .bn-tile { transition: border-color .2s ease; }
                    .bn-card:hover { transform: none; box-shadow: none; }
                }
            `}</style>

            <div className="container mx-auto px-6 md:px-12 lg:px-20 pt-16 lg:pt-24 pb-20 lg:pb-32 flex flex-col gap-12 lg:gap-16 text-left">
                <h2 className="max-w-[760px] text-3xl lg:text-[44px] font-bold leading-[1.1] text-blue10">
                    Built for meaningful work — and a sustainable career.
                </h2>

                <ul className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 p-0 m-0">
                    {benefits.map((benefit) => {
                        const Icon = benefitIcons[benefit.icon];
                        return (
                            <li
                                key={benefit.id}
                                className="bn-card bg-white border border-solid border-FGNeutralAccent rounded-2xl p-7 flex flex-col gap-6 min-h-[250px]"
                            >
                                <span className="bn-tile w-12 h-12 shrink-0 rounded-xl bg-[#EEF1F6] border border-solid border-[#D8DEE7] flex items-center justify-center">
                                    <Icon aria-hidden="true" focusable="false" />
                                </span>
                                <span className="flex flex-col gap-2.5">
                                    <h3 className="text-xl font-bold text-blue10">{benefit.title}</h3>
                                    <p className="text-base leading-[1.5] text-grey45">{benefit.description}</p>
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
};

export default Benefits;
